var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useImperativeHandle } from 'react';
import cn from 'classnames';
import { useBEM } from '../../../utils';
import { Button } from '../../Button';
import { Icon } from '../../Icon';
import { Typography } from '../../Typography';
import "./styles.css";
var _a = useBEM('lk-ui__tab'), tabClassName = _a[0], tabModifier = _a[1], tabElement = _a[2];
var _b = tabElement('label'), tabLabelClassName = _b[0], labelModifier = _b[1];
export var Tab = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var className = _a.className, value = _a.value, label = _a.label, onClick = _a.onClick, iconName = _a.iconName, selected = _a.selected, disabled = _a.disabled, props = __rest(_a, ["className", "value", "label", "onClick", "iconName", "selected", "disabled"]);
    var buttonClassName = cn(tabClassName, (_b = {},
        _b[tabModifier('icon-only')] = iconName && !label,
        _b), className);
    var localRef = useRef(null);
    useImperativeHandle(ref, function () { return localRef.current; });
    var labelClassName = cn(tabLabelClassName, (_c = {},
        _c[labelModifier('selected')] = selected,
        _c));
    var handlerClick = function () {
        var _a;
        (_a = localRef === null || localRef === void 0 ? void 0 : localRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView();
        if (onClick)
            onClick(value);
    };
    return (React.createElement(Button, __assign({ ref: localRef, className: buttonClassName, disabled: disabled, onClick: handlerClick, size: 'small' }, props),
        React.createElement("div", { className: labelClassName },
            iconName && React.createElement(Icon, { iconName: iconName, size: 'large' }),
            label && React.createElement(Typography, { variant: 'subtitle3' }, label),
            React.createElement("div", { className: labelModifier('hover') }))));
});
